import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { MapOptions } from './mapOptions';
import { HttpClient } from '@angular/common/http';
import { Location } from 'app/models/location.model';
import { StopI } from 'app/models/stop.interface';

@Injectable({
  providedIn: 'root'
})
export class MapboxService {

  constructor(private httpClient: HttpClient) { }
  public marker: mapboxgl.Marker;
  map: mapboxgl.Map;
  initialPosition = {
    lng: -69.918883, lat: 18.473837
  }
  initialZoom = 11
  style = 'mapbox://styles/mapbox/streets-v11';
  routeCoordinates: any[];

  public async buildConsumerMap(route: StopI[]){
    this.map = new mapboxgl.Map({
      accessToken: environment.mapboxAccessToken,
      container: 'map',
      zoom: this.initialZoom,
      style: this.style,
      center: [
        this.initialPosition.lng, 
        this.initialPosition.lat
      ]
    });
    // let inst = document.getElementById('instructions');
    // inst.innerHTML = '<p>Hola</p>';

    // console.log('Ruta a escribir', route);
    // console.log('Ruta feature ', this.featureCoordinates(route))
    // return this.getDirection(route);
    // await this.getDirectionAsync(route);
  }

  public buildRouteMap(direction, route: StopI[]){
    this.map = new mapboxgl.Map({
      accessToken: environment.mapboxAccessToken,
      container: 'map',
      zoom: this.initialZoom,
      style: this.style,
      center: [
        this.initialPosition.lng, 
        this.initialPosition.lat
      ]
    });
    this.buildRouteLayer(direction, route);
  }

  buildMap(options?: MapOptions){
    this.map = new mapboxgl.Map({
      accessToken: environment.mapboxAccessToken,
      container: 'map',
      zoom: this.initialZoom,
      style: this.style,
      center: [
        options.marker ? options.marker.lng : this.initialPosition.lng, 
        options.marker ? options.marker.lat : this.initialPosition.lat
      ]
    });
    this.map.addControl(new mapboxgl.NavigationControl(), "bottom-right");
    this.map.addControl(new MapboxGeocoder({
      accessToken: environment.mapboxAccessToken,
      mapboxgl: mapboxgl
    }));
    // mi ubicacion!
    // this.map.addControl(new mapboxgl.GeolocateControl({
    //   positionOptions: {
    //     enableHighAccuracy: true
    //   },
    //   trackUserLocation: true
    // }))
    if(options.marker){
      let geometry: {lng: number, lat: number} = {lng: options.marker.lng, lat: options.marker.lat};
      if(this.marker){
        this.marker.remove();
        this.marker = undefined; 
      }
      this.marker = this.createMarker();
      this.marker.setLngLat(geometry).addTo(this.map);
    }

    this.map.on('click', (e) => {
      let geometry: {lng: number, lat: number} = {lng: e.lngLat.lng, lat: e.lngLat.lat};
      if(this.marker){
        this.marker.remove();
        this.marker = undefined; 
      }
      this.marker = this.createMarker();
      this.marker.setLngLat(geometry).addTo(this.map);
      console.log(this.marker.getLngLat())
    });
  }  

  createMarker(){
    const marker = new mapboxgl.Marker({
      draggable: true
    });
    return marker;
  }

  public getDirection(route: StopI[]){
    let stopsArray: {lng: number, lat: number}[] = [];
    route.forEach(stop => {
      stopsArray.push(stop.location.geoLocation);
    });
    let coordinatesString: string = this.getCoordinatesString(stopsArray);
    let urlDirectionAPI: string = `${environment.mapboxDirectionAPI.url}${coordinatesString}?${environment.mapboxDirectionAPI.geojson}access_token=${environment.mapboxAccessToken}`;
    console.log('URL: ', urlDirectionAPI);
    return this.httpClient.get<any>(urlDirectionAPI);
    // this.httpClient.get<any>(urlDirectionAPI).subscribe((result) => {
      // this.buildRouteLayer(result, route);
      // console.log(result);
      // let data = result.routes[0];
      // let coordinates = data.geometry.coordinates;
      // // this.route_ETA = data.duration;
      // this.routeCoordinates = coordinates;
      // let geojson = {
      //   type: 'Feature',
      //   properties: {},
      //   geometry: {
      //     type: 'LineString',
      //     coordinates: coordinates,
      //   }
      // };

      // if(this.map.getSource('route')){
      //   console.log('ruta existe');
      // }else{
      //   this.map.on('load', () => {
      //     this.map.loadImage('https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png',
      //     (error, image) => {
      //       if(error){
      //         alert(error);
      //       }else{
      //         this.map.addImage('custom-marker', image);
      //         this.map.addSource('points', {
      //           type: 'geojson',
      //           data: {
      //             type: 'FeatureCollection',
      //             features: this.featureCoordinates(route)
      //           } 
      //         });
      //         // Add a symbol layer
      //         this.map.addLayer({
      //           id: 'points',
      //           type: 'symbol',
      //           source: 'points',
      //           layout: {
      //             "icon-image": 'custom-marker',
      //             // get the title name from the source's "title" property
      //             'text-field': ['get', 'title'],
      //             'text-font': [
      //               'Open Sans Semibold',
      //               'Arial Unicode MS Bold'
      //             ],
      //             'text-offset': [0, 1.25],
      //             'text-anchor': 'top'
      //           }
      //         });
      //         this.map.addLayer({
      //           id: 'route',
      //           type: 'line',
      //           source: {
      //             type: 'geojson',
      //             data: {
      //               type: 'Feature',
      //               properties: {},
      //               geometry: {
      //                 type: 'LineString',
      //                 coordinates: coordinates
      //               }
      //             }
      //           },
      //           layout: {
      //             'line-join': 'round',
      //             'line-cap': 'round'
      //           },
      //           paint: {
      //             'line-color': '#3887be',
      //             'line-width': 5,
      //             'line-opacity': 0.75
      //           }
      //         });
      //       }
      //     });
      //   });
      // }
    // });
  }

  private buildRouteLayer(result, route){
    console.log(result);
    let data = result.routes[0];
    let coordinates = data.geometry.coordinates;
    // this.route_ETA = data.duration;
    this.routeCoordinates = coordinates;
    let geojson = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates: coordinates,
      }
    };

    if(this.map.getSource('route')){
      console.log('ruta existe');
    }else{
      this.map.on('load', () => {
        this.map.loadImage('https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png',
        (error, image) => {
          if(error){
            alert(error);
          }else{
            this.map.addImage('custom-marker', image);
            this.map.addSource('points', {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features: this.featureCoordinates(route)
              } 
            });
            // Add a symbol layer
            this.map.addLayer({
              id: 'points',
              type: 'symbol',
              source: 'points',
              layout: {
                "icon-image": 'custom-marker',
                // get the title name from the source's "title" property
                'text-field': ['get', 'title'],
                'text-font': [
                  'Open Sans Semibold',
                  'Arial Unicode MS Bold'
                ],
                'text-offset': [0, 1.25],
                'text-anchor': 'top'
              }
            });
            this.map.addLayer({
              id: 'route',
              type: 'line',
              source: {
                type: 'geojson',
                data: {
                  type: 'Feature',
                  properties: {},
                  geometry: {
                    type: 'LineString',
                    coordinates: coordinates
                  }
                }
              },
              layout: {
                'line-join': 'round',
                'line-cap': 'round'
              },
              paint: {
                'line-color': '#3887be',
                'line-width': 5,
                'line-opacity': 0.75
              }
            });
          }
        });
      });
    }
  }

  private async getDirectionAsync(route: StopI[]){
    let stopsArray: {lng: number, lat: number}[] = [];
    route.forEach(stop => {
      stopsArray.push(stop.location.geoLocation);
    });
    let coordinatesString: string = this.getCoordinatesString(stopsArray);
    let urlDirectionAPI: string = `${environment.mapboxDirectionAPI.url}${coordinatesString}?${environment.mapboxDirectionAPI.geojson}access_token=${environment.mapboxAccessToken}`;
    console.log('URL: ', urlDirectionAPI);
    let routeData = await this.httpClient.get<any>(urlDirectionAPI);
    console.log('routeData: ', routeData);
  }

  private getCoordinatesString(coordinates: {lng: number, lat: number}[]){
    let coordinatesString: string = '';
    coordinates.forEach(coordinate => {
      coordinatesString += `${coordinate.lng},${coordinate.lat};`;
    });
    coordinatesString = coordinatesString.slice(0, -1);
    return coordinatesString;
  }

  private featureCoordinates(coordinates: StopI[]): any[]{
    let featureArray: any[] = [];
    coordinates.forEach(coordinate => {
      let feature = {
        type: 'Feature', 
        geometry: {
          type: 'Point',
          coordinates: [coordinate.location.geoLocation.lng, coordinate.location.geoLocation.lat]
        },
        properties: {
          title: coordinate.location.name
        }
      }
      featureArray.push(feature);
    });

    return featureArray;
  }
}
